export default "__VITE_ASSET__ChFUs7Q1__"